import { createReducer, on, Action } from '@ngrx/store';
import { cleantAuthState, loginError, loginSucces, setUser ,   setPermissions  } from './auth.action';
import { authInitialState, AuthState } from './auth.state';

const _authReducer = createReducer(
    authInitialState,

    on(
        loginSucces,
        (state, action) => ({
        ...state,
        isLogged: true
    })),

    on(
        loginError,
        (state, action) => ({
        ...state,
        isLogged: false
    })),

    on(
        setUser,
        (state, action) => ({
            ...state,
            user: action.user,
            isLogged: true
        }
    )),

    on( setPermissions,
      (state, action) => ({
          ...state,
          user: {
            ...state.user!,
            permission: action.permissions
          },
          isLogged: true
      }
  )),

    on(
        cleantAuthState,
        (state, action) => ({
            ...state,
            user: null,
            isLogged: false,
        })
    )
);

export function AuthReducer(state: AuthState | undefined, action: Action ) {
    return _authReducer(state, action);
}
